import { useMemo } from 'react';
import {
  type CustomFormSubmit,
  useCoreCustomFormSubmits,
} from '@tecnobit-srl/custom-form-submit';
import { useVariantCustomFormSubmits } from '@variant';

export const useCustomFormSubmits = (): CustomFormSubmit[] => {
  const core = useCoreCustomFormSubmits();
  const variant = useVariantCustomFormSubmits();
  return useMemo(() => [...core, ...variant], [core, variant]);
};
